export default {
    isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }
};
